/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiFinalRiskLevel } from './InternalApiFinalRiskLevel';
import {
    InternalApiFinalRiskLevelFromJSON,
    InternalApiFinalRiskLevelFromJSONTyped,
    InternalApiFinalRiskLevelToJSON,
    InternalApiFinalRiskLevelToJSONTyped,
} from './InternalApiFinalRiskLevel';

/**
 * 
 * @export
 * @interface InternalApiFinalRisk
 */
export interface InternalApiFinalRisk {
    /**
     * 
     * @type {InternalApiFinalRiskLevel}
     * @memberof InternalApiFinalRisk
     */
    level: InternalApiFinalRiskLevel;
    /**
     * 
     * @type {number}
     * @memberof InternalApiFinalRisk
     */
    score?: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiFinalRisk
     */
    createdTime: Date;
    /**
     * 
     * @type {string}
     * @memberof InternalApiFinalRisk
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiFinalRisk
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiFinalRisk
     */
    createdBy?: string;
    /**
     * 
     * @type {InternalApiFinalRiskEventEnum}
     * @memberof InternalApiFinalRisk
     */
    event: InternalApiFinalRiskEventEnum;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiFinalRiskEventEnum {
    OVERRIDE_STARTED = 'OVERRIDE_STARTED',
    OVERRIDE_ENDED = 'OVERRIDE_ENDED',
    SCORE_CHANGED = 'SCORE_CHANGED'
}


/**
 * Check if a given object implements the InternalApiFinalRisk interface.
 */
export function instanceOfInternalApiFinalRisk(value: object): value is InternalApiFinalRisk {
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('event' in value) || value['event'] === undefined) return false;
    return true;
}

export function InternalApiFinalRiskFromJSON(json: any): InternalApiFinalRisk {
    return InternalApiFinalRiskFromJSONTyped(json, false);
}

export function InternalApiFinalRiskFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiFinalRisk {
    if (json == null) {
        return json;
    }
    return {
        
        'level': InternalApiFinalRiskLevelFromJSON(json['level']),
        'score': json['score'] == null ? undefined : json['score'],
        'createdTime': (new Date(json['createdTime'])),
        'reason': json['reason'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'event': json['event'],
    };
}

export function InternalApiFinalRiskToJSON(json: any): InternalApiFinalRisk {
    return InternalApiFinalRiskToJSONTyped(json, false);
}

export function InternalApiFinalRiskToJSONTyped(value?: InternalApiFinalRisk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'level': InternalApiFinalRiskLevelToJSON(value['level']),
        'score': value['score'],
        'createdTime': value['createdTime'].toISOString(),
        'reason': value['reason'],
        'comment': value['comment'],
        'createdBy': value['createdBy'],
        'event': value['event'],
    };
}

